module.exports = __webpack_public_path__ + "media/images/covers/foundation/University-of-Lancaster-logo-3d44fc3970bcd560ae167d0d200f04c0.svg";